import { ExportEntity, ExportFormat } from '@enmon/commons/lib/enmon';
import { FilterField } from '@/components/filter/constants';
import { MetersExportTemplate } from './enums/exportTemplate';

export const CREATE_EXPORT_SUCCESS = 'app/routes/exports/CREATE_EXPORT_SUCCESS' as const;
export const CREATE_EXPORT_ERROR = 'app/routes/exports/CREATE_EXPORT_ERROR' as const;

export const EXPORT_DATA_READY = `app/routes/exports/EXPORT_DATA_READY` as const;

export const EDIT_EXPORT_SUCCESS = 'app/routes/exports/EDIT_EXPORT_SUCCESS' as const;
export const EDIT_EXPORT_ERROR = 'app/routes/exports/EDIT_EXPORT_ERROR' as const;

export const TOGGLE_ACTIVE_EXPORT_SUCCESS = 'app/routes/exports/TOGGLE_ACTIVE_EXPORT_SUCCESS' as const;
export const TOGGLE_ACTIVE_EXPORT_ERROR = 'app/routes/exports/TOGGLE_ACTIVE_EXPORT_ERROR' as const;

export const DELETE_EXPORT_SUCCESS = 'app/routes/exports/DELETE_EXPORT_SUCCESS' as const;
export const DELETE_EXPORT_ERROR = 'app/routes/exports/DELETE_EXPORT_ERROR' as const;

export const FORCE_RUN_EXPORT_SUCCESS = 'app/routes/exports/FORCE_RUN_EXPORT_SUCCESS' as const;
export const FORCE_RUN_EXPORT_ERROR = 'app/routes/exports/FORCE_RUN_EXPORT_ERROR' as const;

// SHARED
const COLUMN_UNIT = { key: 'unit', name: 'Jednotka', description: 'Jednotka' } as const;
// METER
const COLUMN_METER_ID = { key: 'meterId', name: 'Id měřidla', description: 'Id měřidla' } as const;
const COLUMN_METER_NAME = { key: 'meterName', name: 'Název měřidla', description: 'Název měřidla' } as const;
const COLUMN_METER_CODE = { key: 'meterCode', name: 'Kód měřidla', description: 'Kód měřidla' } as const;
const COLUMN_METER_SERIAL = { key: 'meterSerial', name: 'Výrobní číslo', description: 'Výrobní číslo' } as const;
const COLUMN_METER_EAN = { key: 'meterEAN', name: 'EAN', description: 'EAN' } as const;
const COLUMN_SUPPLY_POINT_NAME = {
  key: 'supplyPointName',
  name: 'Supply point name',
  description: 'Supply point name',
} as const;
const COLUMN_METER_ACCESS_TOKEN = {
  key: 'meterAccessToken',
  name: 'API klíč',
  description: 'Přístupový klíč pro odečet pomocí mobilní aplikace',
} as const;
const COLUMN_METER_MULTIPLIER = { key: 'meterMultiplier', name: 'Násobitel', description: 'Násobitel' } as const;
const COLUMN_METER_COMMODITY = {
  key: 'meterCommodity',
  name: 'Komodita měřidla',
  description: 'Komodita měřidla',
} as const;
const COLUMN_METER_CALIBRATION = {
  key: 'meterCalibration',
  name: 'Datum expirace cejchu/kalibrace',
  description: 'Datum expirace cejchu/kalibrace',
} as const;
const COLUMN_METER_NOTE = { key: 'meterNote', name: 'Poznámka měřidla', description: 'Poznámka měřidla' } as const;
// ESTABLISHMENT
const COLUMN_ESTABLISHMENT_NAME = {
  key: 'establishmentName',
  name: 'Název provozovny',
  description: 'Název provozovny',
} as const;
const COLUMN_ESTABLISHMENT_CODE = {
  key: 'establishmentCode',
  name: 'Kód provozovny',
  description: 'Kód provozovny',
} as const;
const COLUMN_ESTABLISHMENT_AREA = {
  key: 'establishmentArea',
  name: 'Plocha provozovny',
  description: 'Plocha provozovny',
} as const;

// COUNTER
const COLUMN_COUNTER_START = {
  requiresPeriod: true,
  key: 'counterStart',
  name: 'Stav na začátku období',
  description: 'Stav na začátku vybraného období',
} as const;
const COLUMN_COUNTER_STARTTIME = {
  requiresPeriod: true,
  key: 'counterStartReadTime',
  name: 'Čas odečtu na začátku období',
  description: 'Čas odečtu na začátku vybraného období',
} as const;
const COLUMN_COUNTER_END = {
  requiresPeriod: true,
  key: 'counterEnd',
  name: 'Stav na konci období',
  description: 'Stav na konci vybraného období',
} as const;
const COLUMN_COUNTER_ENDTIME = {
  requiresPeriod: true,
  key: 'counterEndReadTime',
  name: 'Čas odečtu na konci období',
  description: 'Čas odečtu na konci vybraného období',
} as const;
const COLUMN_PREVIOUS_COUNTER_START = {
  requiresPeriod: true,
  key: 'previousCounterStart',
  name: 'Stav na začátku předešlého období',
  description: 'Stav na začátku předešlého období',
} as const;
const COLUMN_PREVIOUS_COUNTER_STARTTIME = {
  requiresPeriod: true,
  key: 'previousCounterStartReadTime',
  name: 'Čas odečtu na začátku předešlého období',
  description: 'Čas odečtu na začátku předešlého období',
} as const;
const COLUMN_PREVIOUS_COUNTER_END = {
  requiresPeriod: true,
  key: 'previousCounterEnd',
  name: 'Stav na konci předešlého období',
  description: 'Stav na konci předešlého období',
} as const;
const COLUMN_PREVIOUS_COUNTER_ENDTIME = {
  requiresPeriod: true,
  key: 'previousCounterEndReadTime',
  name: 'Čas odečtu na konci předešlého období',
  description: 'Čas odečtu na konci předešlého období',
} as const;
const COLUMN_COUNTER_CONSUMPTION = {
  requiresPeriod: true,
  key: 'counterConsumption',
  name: 'Spotřeba ve vybraném období',
  description: 'Spotřeba ve vybraném období',
} as const;
const COLUMN_COUNTER_CONSUMPTION_START = {
  requiresPeriod: true,
  key: 'counterConsumptionStart',
  name: 'Spotřeba v období od začátku předešlého do začátku vybraného období',
  description: 'Spotřeba v období od prvního odečtu předešlého období do prvního odečtu aktuálního období.',
} as const;
const COLUMN_COUNTER_CONSUMPTION_END = {
  requiresPeriod: true,
  key: 'counterConsumptionEnd',
  name: 'Spotřeba v období od konce předešlého do konce vybraného období',
  description: 'Spotřeba v období od posledního odečtu předešlého období do prvního odečtu aktuálního období.',
} as const;

export const COLUMNS = [
  COLUMN_UNIT,
  COLUMN_METER_ID,
  COLUMN_METER_NAME,
  COLUMN_METER_CODE,
  COLUMN_METER_SERIAL,
  COLUMN_METER_EAN,
  COLUMN_METER_MULTIPLIER,
  COLUMN_METER_COMMODITY,
  COLUMN_METER_CALIBRATION,
  COLUMN_METER_NOTE,
  COLUMN_METER_ACCESS_TOKEN,
  COLUMN_SUPPLY_POINT_NAME,
  COLUMN_ESTABLISHMENT_NAME,
  COLUMN_ESTABLISHMENT_CODE,
  COLUMN_ESTABLISHMENT_AREA,
  COLUMN_COUNTER_START,
  COLUMN_COUNTER_STARTTIME,
  COLUMN_COUNTER_END,
  COLUMN_COUNTER_ENDTIME,
  COLUMN_PREVIOUS_COUNTER_START,
  COLUMN_PREVIOUS_COUNTER_STARTTIME,
  COLUMN_PREVIOUS_COUNTER_END,
  COLUMN_PREVIOUS_COUNTER_ENDTIME,
  COLUMN_COUNTER_CONSUMPTION,
  COLUMN_COUNTER_CONSUMPTION_START,
  COLUMN_COUNTER_CONSUMPTION_END,
] as const;

export const TEMPLATES = {
  [MetersExportTemplate.MeterCounter]: {
    template: MetersExportTemplate.MeterCounter,
    exportEntity: ExportEntity.Meters,
    columns: [
      COLUMN_ESTABLISHMENT_NAME,
      COLUMN_METER_NAME,
      COLUMN_METER_CODE,
      COLUMN_UNIT,
      COLUMN_COUNTER_ENDTIME,
      COLUMN_COUNTER_END,
    ],
    format: null,
    sortBy: COLUMN_ESTABLISHMENT_NAME.key,
  },
  [MetersExportTemplate.MeterInvoicing]: {
    template: MetersExportTemplate.MeterInvoicing,
    exportEntity: ExportEntity.Meters,
    columns: [
      COLUMN_ESTABLISHMENT_NAME,
      COLUMN_ESTABLISHMENT_CODE,
      COLUMN_METER_NAME,
      COLUMN_METER_CODE,
      COLUMN_UNIT,
      COLUMN_PREVIOUS_COUNTER_END,
      COLUMN_PREVIOUS_COUNTER_ENDTIME,
      COLUMN_COUNTER_END,
      COLUMN_COUNTER_ENDTIME,
      COLUMN_COUNTER_CONSUMPTION_END,
    ],
    format: null,
    sortBy: COLUMN_ESTABLISHMENT_NAME.key,
  },
} as const;

export const FILENAME_SUFFIX_MAP: Record<ExportFormat, string> = {
  [ExportFormat.CSV]: '.csv',
  [ExportFormat.JSON]: '.json',
  [ExportFormat.TXT]: '.txt',
  [ExportFormat.XLS]: '.xlsx',
  [ExportFormat.XML]: '.xml',
} as const;

export const PICKED_FILTER_FIELDS_EXPORTS = [FilterField.Search] as const;
export const REQUIRED_FILTER_FIELDS_EXPORTS = {} as const;

export const INITIAL_PAGINATION_EXPORTS = { pageSize: 20, sort: '-createdAt' } as const;
